import type { FaireProductEntity } from "../../entity_types/product";

export const p_4mtg6vqmw4: FaireProductEntity = {
  token: "p_4mtg6vqmw4",
  type: "product",
  name: "Boho Patchwork Sacred Ember Long Maxi Skirt",
  brandToken: "b_ch3tzpim",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2644ba352ca4b0b9b312eedcc076a4dd7395e7399d12e32149a5ec900934f354.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e741bbfef79e411a7eb67f2bb0dd7dabd554410402219aebae98cc6204048ba.jpeg",
    "https://cdn.faire.com/fastly/cbec3ecc428466771a43d38c6d777151ec213a9c9574b260791916d4bbd53f16.jpeg",
    "https://cdn.faire.com/fastly/d069c9c9ab2d63ac497be82c5d7149cd515d586defcb6632cf469de7454c68db.jpeg",
    "https://cdn.faire.com/fastly/a46996e7f996ecd30c5dbd325d75d986d8ce25edc5ec2182c7512fc295c5dd9f.jpeg",
    "https://cdn.faire.com/fastly/f7750c9762d994fcc3a50228b665cdfb3df5e6bc19dded8a6aa775a9c4afa1cf.jpeg",
    "https://cdn.faire.com/fastly/620829adb5c320709f41044200627f78b0c9e67e69437db5cbd6a77739d06089.jpeg",
    "https://cdn.faire.com/fastly/92f993d6b41c944920727b2aa21c5c9c2766976e50b62c693d90ddf4f9bd5dfc.jpeg",
    "https://cdn.faire.com/fastly/e3a79f4632c4a34ce2d878221cc5bd79d58380080d462fd4d9209b460d79c1f9.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "Unleash your inner free spirit with our Boho Patchwork Sacred Ember Long Maxi Skirt, a vibrant blend of artistic patchwork, flowing elegance, and soulful bohemian charm. Each skirt is lovingly handcrafted from assorted fabric pieces, creating a unique mosaic of warm ember tones, earthy hues, and eclectic patterns—meaning no two skirts are ever the same.\n\nDesigned with a graceful ankle-length silhouette, this maxi skirt moves beautifully with every step. The soft, breathable cotton and comfortable elastic waistband make it perfect for all-day wear, whether you're strolling through markets, traveling, or enjoying sunny outdoor moments.\n\nNote: This one-of-a-kind item is handmade and may appear in colors other than shown.\n\n100% cotton\nHand wash\nMade in Nepal",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:26.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
